import { Mail, X } from "lucide-react";
import { useTranslation } from "react-i18next";

// Почта — единственное поле анкеты держателя, которое обязано быть настоящим:
// на неё платёжная система оформляет держателя карты. Без неё выпуск отвергается
// на стороне провайдера.
//
// Раньше это выяснялось в самом конце: человек выбирал сумму, жал «Выпустить» и
// получал тост, который его же с экрана и уносил в профиль — без объяснения,
// зачем почта вообще нужна. Теперь проверка идёт на входе, а требование
// объясняется словами.
//
// Иконка намеренно НЕ красная. Красный означает «что-то сломалось», а здесь
// ничего не сломалось: от человека просто нужен один шаг, который он может
// сделать прямо сейчас.
const EmailRequiredDialog = ({ open, onGoToProfile, onLater }) => {
  const { t } = useTranslation();

  if (!open) return null;

  return (
    <div
      className="lp-scrim--fixed z-[90] flex items-center justify-center p-4"
      data-testid="email-required-dialog"
    >
      <div className="lp-veil lp-veil--edged rounded-[22px] relative w-full max-w-md p-6 text-center">
        <button
          type="button"
          onClick={onLater}
          className="absolute right-4 top-4 inline-flex h-8 w-8 items-center justify-center rounded-full text-muted-foreground"
          aria-label={t("cards.email_required_later")}
        >
          <X className="h-4 w-4" />
        </button>

        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-primary/10 ring-1 ring-inset ring-primary/40">
          <Mail className="h-7 w-7 text-link" />
        </div>

        <h3 className="mt-4 text-xl font-semibold text-foreground">
          {t("cards.email_required_title")}
        </h3>
        <p className="mt-2 text-sm leading-relaxed text-foreground/80">
          {t("cards.email_required_body")}
        </p>
        <p className="mt-2 text-xs leading-relaxed text-muted-foreground">
          {t("cards.email_required_hint")}
        </p>

        <button
          type="button"
          onClick={onGoToProfile}
          className="mt-5 w-full rounded-xl bg-primary px-4 py-3.5 text-sm font-semibold text-primary-foreground"
          data-testid="email-required-cta"
        >
          {t("cards.email_required_cta")}
        </button>
        <button
          type="button"
          onClick={onLater}
          className="mt-2 w-full rounded-xl border border-[rgb(var(--lp-edge)/var(--lp-edge-a))] px-4 py-3 text-sm font-semibold text-link"
          data-testid="email-required-later"
        >
          {t("cards.email_required_later")}
        </button>
      </div>
    </div>
  );
};

export default EmailRequiredDialog;
